import React, {useEffect, useState} from "react";
import {Color, HEX, RGBArray, RGBTuple} from '../types/colors';
import {baseTenToSixteen} from "../converters/math";
import {hexToRGBArray, parseRGBTuple, rgbToHex} from "../converters/colors";
import HexCube, {Cube} from "../builder/HexCube"
import {XYZArray} from "../types/math";

function getSpot(inputRGB:RGBArray, cube:Cube):XYZArray;
function getSpot(inputRGB:RGBArray, cube:Cube, showColor:boolean):[XYZArray, HEX];
function getSpot(inputRGB:RGBArray, cube:Cube, showColor?:boolean):XYZArray|[XYZArray,HEX]{
    // Function to calculate Euclidean distance between two RGB colors
    let colorDistance = (rgb1: RGBArray, rgb2: RGBArray): number => {
        const [r1, g1, b1] = rgb1;
        const [r2, g2, b2] = rgb2;
        return Math.sqrt(
            Math.pow(r2 - r1, 2) +
            Math.pow(g2 - g1, 2) +
            Math.pow(b2 - b1, 2)
        );
    }

    let minDistance = Infinity;
    let closestPosition: XYZArray = [0, 0, 0];
    let closestColor: RGBTuple = `(0,0,0)`;

    // Iterate through the 3D cube
    for (let i = 0; i < cube.length; i++) {
        for (let j = 0; j < cube[i].length; j++) {
            for (let k = 0; k < cube[i][j].length; k++) {
                const cubeRGBTuple = cube[i][j][k];
                const cubeRGB = parseRGBTuple(cubeRGBTuple);
                const distance = colorDistance(inputRGB, cubeRGB);

                if (distance < minDistance) {
                    minDistance = distance;
                    closestPosition = [i, j, k];
                    closestColor = cubeRGBTuple;
                }
            }
        }
    }

    return showColor? [closestPosition, rgbToHex(parseRGBTuple(closestColor))] : closestPosition;
}

function showSlices([x,y,z]:XYZArray, cube:Cube){

    let remReduction = 1//5/8// 1/2;

     let getSlice = (slice:"length"|"width"|"depth")=>{
         let cubeLength:number[]=[];
         // length restriction for A
         cubeLength.push(slice=="length"||slice=="width"?cube.length:cube[x].length)

         let builder:  React.JSX.Element[] = [];
         for (let a = 0; a < cubeLength[0]; a++) {

             // length restriction for B
             cubeLength.push(
                 slice=="length"?
                     cube[a].length:
                 slice=="width"?
                     cube[a][y].length:
                     cube[x][a].length
             )

             let rows: React.JSX.Element[] = []
             for (let b = 0; b < cubeLength[1]; b++) {

                 let spot:string;
                 let picked:boolean;
                 let upperlower:boolean = a+b+1 >= cubeLength[0]
                 try {
                     switch (slice) {
                         case "length":
                             spot = cube[a][b][z];
                             picked = (x == a && y == b);
                             break;
                         case "width":
                             spot = cube[a][y][b];
                             picked = (x == a && z == b);
                             break;
                         case "depth":
                             spot = cube[x][a][b];
                             picked = (y == a && z == b);
                             break;
                         default:
                             throw new Error("Don't end up here")
                     }
                 }
                 catch (err){
                    if(err instanceof TypeError){
                        console.error(
`
Error Drawing Grid with properties:
xyz: ${x},${y},${z}
a,b: ${a},${b}
plane: ${slice}
-----
cube lengths:
len:${cubeLength}
x: ${cube.length}
y: ${cube[x].length}
z: ${cube[x][y].length}
-----
Error: ${err}
`
                        )

                        continue; // skip this piece of the for loop on error

                    }else{
                        throw err
                    }
                 }

                 // todo use converter
                 let [intX, intY, intZ] = spot.split(",").map(value=>value.replace("(","").replace(")","").trim())
                 // console.log(intX, intY, intZ)

                 rows.push(
                     <td style={{
                         fontSize:1*remReduction+"rem",
                         width:5*remReduction+'rem',
                         height:2.5*remReduction+'rem',
                         margin: 0,
                         padding: 0,
                         display:'inline-block',
                         boxSizing:'border-box',
                         // verticalAlign:"middle",
                         alignContent:"space-evenly",
                         backgroundColor:`#${intX}${intY}${intZ}`,
                         color:picked?"white":upperlower?"black":"lightgrey",
                         textDecoration:picked?'underline':'none',
                     }}>{spot}</td>
                 )
             }
             builder.push(<tr style={{display:'flex'}}>{rows}</tr>)
         }


         return <table style={{
             padding:0,
             margin:'0 auto',
             borderSpacing:0,

         }}
         >{builder}</table>
     }

     // todo text color options
     return (<div>
         <hr/>
         Blue Fixed<br/>
         { getSlice("length")}
         <hr/>
         Green Fixed<br/>
         { getSlice("width")}
         <hr/>
         Red Fixed<br/>
         { getSlice("depth")}
         <hr/>

     </div>)
}

function ColorGrid( {color, hexcube}:{color:HEX, hexcube:Cube} ){

    let inputRGB = hexToRGBArray(color);
    let [spot, closestColor] = getSpot(inputRGB, hexcube, true)


    return (<>
        <div>
            <span>Displaying closest color to your picked color. Make grid larger to have more granularity.</span><br/>
            <span>input:{color}</span>&nbsp;<span>closest on grid:{closestColor}</span>
        </div>
        {showSlices(spot,hexcube)}
        </>)
}

export default ColorGrid
